import request from '@/utils/request'
import { selectApi } from '@/config/config'
import { getUserInfo } from '@/utils/common'

// 获取指标数据
export const getTopTarget = () => {
  const userInfo  = getUserInfo()
  return request('/api/xtgl_ygxx/editData.do', {
    params: {
      id: userInfo.userid,
    }
  })
}

// 获取我的审批-待审核
export const getWdspDsh = (params) => {
  const userInfo  = getUserInfo()
  return request(selectApi, {
    params: {
      sqlfilename: 'sql-zcoa.xml',
      sqlkey: 'gzt-wdsp-dsh-list',
      userid: userInfo.userid,
      ...params
    }
  })
}

// 获取我的审批-已审核
export const getWdspYsh = (params) => {
  const userInfo  = getUserInfo()
  return request(selectApi, {
    params: {
      sqlfilename: 'sql-zcoa.xml',
      sqlkey: 'gzt-wdsp-ysh-list',
      userid: userInfo.userid,
      ...params
    }
  })
}

// 非审批类-财务事项-待开票
export const getCwsxDkp = (params={}) => {
  const userInfo  = getUserInfo()
  return request(selectApi, {
    params: {
      sqlfilename: 'sql-zcoa.xml',
      sqlkey: 'gzt-fsplcwsx-dkp-list',
      userid: userInfo.userid,
      ...params
    }
  })
}

// 非审批类-财务事项-待开票记账
export const getCwsxDkpjz = (params={}) => {
  const userInfo  = getUserInfo()
  return request(selectApi, {
    params: {
      sqlfilename: 'sql-zcoa.xml',
      sqlkey: 'gzt-fsplcwsx-dkpjz-list',
      userid: userInfo.userid,
      ...params
    }
  })
}

// 非审批类-财务事项-待收款记账
export const getCwsxDskjz = (params={}) => {
  const userInfo  = getUserInfo()
  return request(selectApi, {
    params: {
      sqlfilename: 'sql-zcoa.xml',
      sqlkey: 'gzt-fsplcwsx-dskjz-list',
      userid: userInfo.userid,
      ...params
    }
  })
}

// 统计数据
export const getCount = () => {
  const userInfo  = getUserInfo()
  return request('/api/djshlcpz/getTotal.do', {
    params: {
      userid: userInfo.userid,
    }
  })
}

// 统计数据
export const getCountByDrzgqk = () => {
  const userInfo  = getUserInfo()
  return request('/api/djshlcpz/getTotalByDrzgqk.do', {
    params: {
      userid: userInfo.userid,
    }
  })
}

// 统计数据
export const getCountByPjclsc = () => {
  const userInfo  = getUserInfo()
  return request('/api/djshlcpz/getTotalByPjclsc.do', {
    params: {
      userid: userInfo.userid,
    }
  })
}

// 统计数据
export const getMyEntrustCount = (params) => {
  const userInfo  = getUserInfo()
  return request('/api/djshlcpz/getTotalByDsh.do', {
    params: {
      userid: userInfo.userid,
      ...params
    }
  })
}

// 获取我的单据
export const getMyOrder = (params, sqlkey) => {
  const userInfo  = getUserInfo()
  return request(selectApi, {
    params: {
      sqlfilename: 'sql-zcoa.xml',
      sqlkey,
      userid: userInfo.userid,
      ...params
    }
  })
}
